import sha256 from 'sha256';

// Track last push to prevent duplicates
let lastPushTimestamp = 0;
let lastPushedUserId = null;
const DEBOUNCE_TIME = 1000; // 1 second

/**
 * Pushes authenticated user data to dataLayer for analytics tracking
 * This should be called on every page when a user is logged in
 * Includes debouncing to prevent duplicate calls
 * 
 * @param {Object} user - The user object containing user information
 * @param {string} event - The event name to push (default: 'userDataLoaded')
 */
export const pushUserDataToDataLayer = (user, event = 'userDataLoaded') => {
    if (!user || typeof dataLayer === 'undefined') {
        return;
    }

    const now = Date.now();

    // Prevent duplicate calls for the same user within debounce time
    if (lastPushedUserId === user.id && (now - lastPushTimestamp) < DEBOUNCE_TIME) {
        return;
    }

    dataLayer.push({
        userId: user.id,
        customer: true,
        userEmail: user.email ? user.email : null,
        userFirstName: user.first_name ? user.first_name : null,
        userLastName: user.last_name ? user.last_name : null,
        userPhone: user.phone ? user.phone.replace(/\s/g, '') : null,
        event: event,
    });

    lastPushTimestamp = now;
    lastPushedUserId = user.id;
};
